export const errors = {
  UNAUTHORIZED_CONNECTION_NO_TOKEN: 'UNAUTHORIZED_CONNECTION_NO_TOKEN',
  UNAUTHORIZED_CONNECTION_INVALID_TOKEN:
    'UNAUTHORIZED_CONNECTION_INVALID_TOKEN',
  PASSWORD_RESET_REQUIRED: 'PASSWORD_RESET_REQUIRED',
  CONNECTION_ERROR: 'CONNECTION_ERROR',
  WRONG_DATA: 'WRONG_DATA',
};
